'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var getSymbols = require('../compat/_internal/getSymbols.js');
var getTag = require('../compat/_internal/getTag.js');
var tags = require('../compat/_internal/tags.js');
var isPrimitive = require('../predicate/isPrimitive.js');
var isTypedArray = require('../predicate/isTypedArray.js');
function cloneDeepWith(obj, cloneValue) {
    return cloneDeepWithImpl(obj, undefined, obj, new Map(), cloneValue);
}
function cloneDeepWithImpl(valueToClone, keyToClone, objectToClone) {
    var stack = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new Map(), cloneValue = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : undefined;
    var cloned = cloneValue === null || cloneValue === void 0 ? void 0 : cloneValue(valueToClone, keyToClone, objectToClone, stack);
    if (cloned != null) {
        return cloned;
    }
    if (isPrimitive.isPrimitive(valueToClone)) {
        return valueToClone;
    }
    if (stack.has(valueToClone)) {
        return stack.get(valueToClone);
    }
    if (Array.isArray(valueToClone)) {
        var result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(var i = 0; i < valueToClone.length; i++){
            result[i] = cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        }
        if (Object.hasOwn(valueToClone, 'index')) {
            result.index = valueToClone.index;
        }
        if (Object.hasOwn(valueToClone, 'input')) {
            result.input = valueToClone.input;
        }
        return result;
    }
    if (valueToClone instanceof Date) {
        return new Date(valueToClone.getTime());
    }
    if (valueToClone instanceof RegExp) {
        var result1 = new RegExp(valueToClone.source, valueToClone.flags);
        result1.lastIndex = valueToClone.lastIndex;
        return result1;
    }
    if (valueToClone instanceof Map) {
        var result2 = new Map();
        stack.set(valueToClone, result2);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = valueToClone[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                result2.set(key, cloneDeepWithImpl(value, key, objectToClone, stack, cloneValue));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result2;
    }
    if (valueToClone instanceof Set) {
        var result3 = new Set();
        stack.set(valueToClone, result3);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = valueToClone[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var value1 = _step1.value;
                result3.add(cloneDeepWithImpl(value1, undefined, objectToClone, stack, cloneValue));
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return result3;
    }
    if (typeof Buffer !== 'undefined' && Buffer.isBuffer(valueToClone)) {
        return valueToClone.subarray();
    }
    if (isTypedArray.isTypedArray(valueToClone)) {
        var result4 = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result4);
        for(var i1 = 0; i1 < valueToClone.length; i1++){
            result4[i1] = cloneDeepWithImpl(valueToClone[i1], i1, objectToClone, stack, cloneValue);
        }
        return result4;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && valueToClone instanceof SharedArrayBuffer) {
        return valueToClone.slice(0);
    }
    if (valueToClone instanceof DataView) {
        var result5 = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result5);
        copyProperties(result5, valueToClone, objectToClone, stack, cloneValue);
        return result5;
    }
    if (typeof File !== 'undefined' && valueToClone instanceof File) {
        var result6 = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result6);
        copyProperties(result6, valueToClone, objectToClone, stack, cloneValue);
        return result6;
    }
    if (valueToClone instanceof Blob) {
        var result7 = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result7);
        copyProperties(result7, valueToClone, objectToClone, stack, cloneValue);
        return result7;
    }
    if (valueToClone instanceof Error) {
        var result8 = new valueToClone.constructor();
        stack.set(valueToClone, result8);
        result8.message = valueToClone.message;
        result8.name = valueToClone.name;
        result8.stack = valueToClone.stack;
        result8.cause = valueToClone.cause;
        copyProperties(result8, valueToClone, objectToClone, stack, cloneValue);
        return result8;
    }
    if ((typeof valueToClone === "undefined" ? "undefined" : _type_of(valueToClone)) === 'object' && isCloneableObject(valueToClone)) {
        var result9 = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result9);
        copyProperties(result9, valueToClone, objectToClone, stack, cloneValue);
        return result9;
    }
    return valueToClone;
}
function copyProperties(target, source) {
    var objectToClone = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : target, stack = arguments.length > 3 ? arguments[3] : void 0, cloneValue = arguments.length > 4 ? arguments[4] : void 0;
    var keys = _to_consumable_array(Object.keys(source)).concat(_to_consumable_array(getSymbols.getSymbols(source)));
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) {
            target[key] = cloneDeepWithImpl(source[key], key, objectToClone, stack, cloneValue);
        }
    }
}
function isCloneableObject(object) {
    switch(getTag.getTag(object)){
        case tags.argumentsTag:
        case tags.arrayTag:
        case tags.arrayBufferTag:
        case tags.dataViewTag:
        case tags.booleanTag:
        case tags.dateTag:
        case tags.float32ArrayTag:
        case tags.float64ArrayTag:
        case tags.int8ArrayTag:
        case tags.int16ArrayTag:
        case tags.int32ArrayTag:
        case tags.mapTag:
        case tags.numberTag:
        case tags.objectTag:
        case tags.regexpTag:
        case tags.setTag:
        case tags.stringTag:
        case tags.symbolTag:
        case tags.uint8ArrayTag:
        case tags.uint8ClampedArrayTag:
        case tags.uint16ArrayTag:
        case tags.uint32ArrayTag:
            {
                return true;
            }
        default:
            {
                return false;
            }
    }
}
exports.cloneDeepWith = cloneDeepWith;
exports.cloneDeepWithImpl = cloneDeepWithImpl;
exports.copyProperties = copyProperties;
